/* eslint-disable react/prop-types */
import React from 'react';
import { CCol, CFormCheck, CRow } from '@coreui/react';
import { useShowConfirmation } from 'src/hooks/useShowConfirmation';
import Button from '../UI/Button';

const Inputs = ({
  inputFields,
  yesFn,
  submitFn,
  children,
  isBtn,
  isShowCancelBtn = true,
  disableSubmit = false,
  errors = [],
}) => {
  const showConfirmation = useShowConfirmation();
  const confirmationModal = () => {
    showConfirmation({
      header: 'Confirmation!',
      body: 'Are you sure you want to cancel?',
      isOpen: true,
      onYes: () => {
        showConfirmation({
          isOpen: false,
        }),
          yesFn();
      },
      onNo: () =>
        showConfirmation({
          isOpen: false,
        }),
    });
  };
  const getColWidth = (inputName) => {
    const fullWidthFields = ['isTermsAccepted', 'avatar', 'ssnNo'];
    const smallWidthFields = [
      'primaryContact',
      'isWhatsAppAsso',
      'isWhatsappAsso',
      'contact',
      'hasValidDrivingLicense',
      'licenseNo',
    ];

    if (fullWidthFields.includes(inputName)) {
      return 12;
    } else if (smallWidthFields.includes(inputName)) {
      return 3;
    } else {
      return 6;
    }
  };

  return (
    <React.Fragment>
      <CRow>
        {inputFields.map((input, index) => {
          const { condition = true } = input;
          if (!condition) return null;
          const FieldComponent = input.component;
          const conditionalProps = Object.fromEntries(
            Object.entries(input).filter(([key, value]) => value !== null && value !== undefined),
          );
          const colWidth = input?.colWidth || getColWidth(input.name);
          return (
            <CCol key={index} xl={colWidth} className="">
              <FieldComponent {...conditionalProps} />
              {errors[input.name] && (
                <div className="text-danger small mt-1">{errors[input.name]}</div>
              )}
            </CCol>
          );
        })}
        {children}
      </CRow>
      {isBtn !== false && (
        <CRow className="CenterAlign gap-3">
          {isShowCancelBtn && <Button title="Cancel" onClick={confirmationModal} />}
          <Button title="Submit" type="submit" onClick={submitFn} disabled={disableSubmit} />
        </CRow>
      )}
    </React.Fragment>
  );
};

export default Inputs;
